<template>
  <div>
    <app-header title=""></app-header>

    <div v-if="!loading" class="container my-5">
      <div class="card mb-4">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col d-flex align-items-center">
              <h2 class="card-title text-truncate mb-0">{{ template.title }}</h2>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-sm btn-link" v-c-modal:modal="{}">
                <i class="far fa-pencil-alt"></i> Edit
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-lg-3">
              <p>
                <span class="data-label">Type</span>
                {{ template.type }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <h2>Template</h2>
      <div class="card">
        <div class="card-body document-preview">
          <wysiwyg-inline :content="template.body" :save="saveHtml"></wysiwyg-inline>
        </div>
      </div>
    </div>

    <sign-request-template-modal
      v-if="!loading"
      ref="modal"
      title="Update Template"
      :template="template"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { WysiwygInline } from 'components/form/input'
import SignRequestTemplateModal from './sign-request-templates/SignRequestTemplateModal'

export default {
  components: {
    WysiwygInline,
    SignRequestTemplateModal
  },

  data () {
    return {
      loading: true
    }
  },

  computed: {
    ...mapState('signRequestTemplate', { template: 'single' })
  },

  created () {
    this.getTemplate(this.$route.params.template_id).then(() => {
      this.loading = false
    })
  },

  methods: {
    ...mapActions('signRequestTemplate', { getTemplate: 'getSingle', updateTemplate: 'updateSingle' }),

    saveHtml (data) {
      return this.updateTemplate({ id: this.template.id, payload: { body: data } })
    }
  }
}
</script>

<style>
.cover-page .top .cover_header_1 {
  position: absolute;
  top: 70mm;
  left: 20mm;
  font-family: 'Quarca';
  font-size: 60pt;
}

.cover-page .top .cover_header_1 h1 {
  position: inherit;
  top: 0px;
  left: 0px;
  font-family: 'Quarca';
  font-size: 60pt;
  margin: 0px;
}

.ck.ck-editor__editable_inline {
  padding: 0px;
}
</style>
